import type { useTranslation } from "react-i18next";

import { HTTP_CONFLICT, HTTP_NOT_FOUND, HttpError } from "./api";

type TFn = ReturnType<typeof useTranslation>["t"];

export type TokenAction = "rotate" | "remove" | "rotationInterval";

// Тексты 409 по действию; у действия без ключа 409 — обычная generic-ошибка.
const CONFLICT_MESSAGE_KEYS: Readonly<Partial<Record<TokenAction, string>>> = {
  rotate: "connections.tokens.rotateNotSupported",
  remove: "connections.tokens.errors.ownerCredentialsRejected",
};

// 404 на действие над ролью: живой строки больше нет, список устарел.
// Тем же 404 бэкенд отвечает и при отсутствии подключения к хосту; тело
// клиент не разбирает, поэтому оба случая получают один текст и перезапрос.
export function isTokenGone(err: unknown): boolean {
  return err instanceof HttpError && err.status === HTTP_NOT_FOUND;
}

// Человекочитаемый текст отказа действия над токеном роли — по статусу HTTP
// (тело ответа клиент не разбирает), иначе generic с сообщением.
export function describeTokenActionError(
  action: TokenAction,
  err: unknown,
  t: TFn,
): string {
  if (isTokenGone(err)) {
    return t("connections.tokens.errors.tokenGone");
  }
  const conflictKey = CONFLICT_MESSAGE_KEYS[action];
  if (
    err instanceof HttpError &&
    err.status === HTTP_CONFLICT &&
    conflictKey !== undefined
  ) {
    return t(conflictKey);
  }
  const message = err instanceof Error ? err.message : String(err);
  return t("connections.genericError", { message });
}
